// The one place that knows how the backend is asked for a section of the alarms screen (story 162).
//
// Wired to sun's published contract (`stories/162-…/contrato-sun.md`). No endpoint is new: the three the screen
// already used accept an OPTIONAL section, and leaving it out is exactly the behaviour from before the split.
// That is what keeps other consumers of these endpoints untouched. `section` is '' when the view is not split
// (the notifications screen), and then it is simply not sent.
import { apiPost, apiPut } from '../../generic/Api_Functions'

// The section travels as a query parameter, as it does for "mark all as read". Not in the paging body: that
// body is the paging class half the application shares, and a concept of this story does not belong in it.
const sectionQuery = (section) => (section ? '?section=' + section : '')

const fetchErrorLogPage = (section, levels, unChecked, pagination) =>
  apiPost('getErrorLogs/' + levels.join(',') + '/' + (unChecked ? 'true' : 'false') + sectionQuery(section), pagination)

// Whoever shows an unread count can hear when alarms were just marked, so the count follows the reading at
// once instead of on its next poll. Only a mark the backend accepted is announced: after a failure there
// is nothing new to fetch. The listeners re-ask the server; nobody paints the new count locally, because an
// automation alarm read by hand can come back unread on the next cycle.
const markListeners = new Set()
const onAlarmsMarked = (listener) => {
  markListeners.add(listener)
  return () => markListeners.delete(listener)
}
const announced = (result) => {
  markListeners.forEach((listener) => listener())
  return result
}

// Limited to the open section: marking everything read in General alarms may not touch the automation alarms,
// and the other way round.
const markAllErrorLogs = (section, levels, checked) =>
  apiPut('setAllErrorLogState/' + levels.join(',') + '/' + checked + sectionQuery(section)).then(announced)

// One alarm by id needs no section: the backend knows which one it is. On an automation alarm the effect is a
// reading for everyone, but the call is the same.
const markErrorLogs = (ids, checked) =>
  apiPut('setErrorLogState/' + ids.join(',') + '/' + checked).then(announced)

// The unread count of each section, from the summary the top bar already polls. `generalAlarms` is unread for
// this user, by subscription; `automationAlarms` is unread for everyone, and the backend sends 0 to a user
// without the automation permission. A summary from before the split only carries the total, which is then
// the general count.
const countOf = (value) => (Number.isInteger(value) && value >= 0 ? value : 0)
const alarmCountsBySection = (summary) => {
  const hasSplit = Number.isInteger(summary?.generalAlarms) || Number.isInteger(summary?.automationAlarms)
  if (!hasSplit) return { general: countOf(summary?.alarms), automation: 0 }
  return { general: countOf(summary.generalAlarms), automation: countOf(summary.automationAlarms) }
}

export { fetchErrorLogPage, markAllErrorLogs, markErrorLogs, alarmCountsBySection, onAlarmsMarked }
